var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH2HPinAdded({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4854 3.51474C22.6885 5.71758 23.9485 8.6909 23.999 11.806C24.0496 14.921 22.8866 17.9336 20.7561 20.2067L20.4854 20.4867L14.8281 26.1427C14.1102 26.8601 13.1466 27.2778 12.1323 27.3112C11.118 27.3447 10.1289 26.9913 9.36541 26.3227L9.17341 26.1427L3.51474 20.4854C1.26429 18.235 0 15.1827 0 12.0001C0 8.81746 1.26429 5.76519 3.51474 3.51474C5.76519 1.26429 8.81746 0 12.0001 0C15.1827 0 18.235 1.26429 20.4854 3.51474Z",
    fill: "#00C950"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 12.1L11.1 14.5L15.3 9.6",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH2HPinAdded);
export default __webpack_public_path__ + "static/media/h2h-pin-added.3f57c2ab18ac3ff98c505c28fea8548a.svg";
export { ForwardRef as ReactComponent };